export const equipmentConstants = {
  FETCH_SFI_EQUIPMENT_TREE_SUCCESS: 'FETCH_SFI_EQUIPMENT_TREE_SUCCESS',
  FETCH_SFI_EQUIPMENT_TREE_LOADING: 'FETCH_SFI_EQUIPMENT_TREE_LOADING',
  FETCH_SFI_EQUIPMENT_TREE_ERROR: 'FETCH_SFI_EQUIPMENT_TREE_ERROR',

  FETCH_SFI_TREE_SUCCESS: 'FETCH_SFI_TREE_SUCCESS',
  FETCH_SFI_TREE_LOADING: 'FETCH_SFI_TREE_LOADING',
  FETCH_SFI_TREE_ERROR: 'FETCH_SFI_TREE_LOADING',

  SAVING_NEW_EQUIPMENT: 'SAVING_NEW_EQUIPMENT',
  SAVING_NEW_EQUIPMENT_SUCCESS: 'SAVING_NEW_EQUIPMENT_SUCCESS',
  SAVING_NEW_EQUIPMENT_ERROR: 'SAVING_NEW_EQUIPMENT_ERROR',

  UPDATE_EQUIPMENT: 'UPDATE_EQUIPMENT',
  UPDATE_EQUIPMENT_SUCCESS: 'UPDATE_EQUIPMENT_SUCCESS',
  UPDATE_EQUIPMENT_ERROR: 'UPDATE_EQUIPMENT_ERROR',

  DELETE_EQUIPMENT: 'DELETE_EQUIPMENT',
  DELETE_EQUIPMENT_SUCCESS: 'DELETE_EQUIPMENT_SUCCESS',
  DELETE_EQUIPMENT_ERROR: 'DELETE_EQUIPMENT_ERROR',

  FETCH_DOCUMENTS: 'FETCH_DOCUMENTS',
  FETCH_DOCUMENTS_SUCCESS: 'FETCH_DOCUMENTS_SUCCESS',
  FETCH_DOCUMENTS_ERROR: 'FETCH_DOCUMENTS_ERROR',

  FETCH_EQUIPMENT_ID_AND_TITLE_LOADING: 'FETCH_EQUIPMENT_ID_AND_TITLE_LOADING',
  FETCH_EQUIPMENT_ID_AND_TITLE_SUCCESS: 'FETCH_EQUIPMENT_ID_AND_TITLE_SUCCESS',
  FETCH_EQUIPMENT_ID_AND_TITLE_ERROR: 'FETCH_EQUIPMENT_ID_AND_TITLE_ERROR',

  FETCH_EQUIPMENTS_FOR_BOAT: 'FETCH_EQUIPMENTS_FOR_BOAT',
  FETCH_EQUIPMENTS_FOR_BOAT_SUCCESS: 'FETCH_EQUIPMENTS_FOR_BOAT_SUCCESS',
  FETCH_EQUIPMENTS_FOR_BOAT_ERROR: 'FETCH_EQUIPMENTS_FOR_BOAT_ERROR',

  FETCH_DETAILS_FOR_EQUIPMENT: 'FETCH_DETAILS_FOR_EQUIPMENT',
  FETCH_DETAILS_FOR_EQUIPMENT_SUCCESS: 'FETCH_DETAILS_FOR_EQUIPMENT_SUCCESS',
  FETCH_DETAILS_FOR_EQUIPMENT_ERROR: 'FETCH_DETAILS_FOR_EQUIPMENT_ERROR',

  FETCH_EQUIPMENTS_FOR_DASHBOARD: 'FETCH_EQUIPMENTS_FOR_DASHBOARD',
  FETCH_EQUIPMENTS_FOR_DASHBOARD_SUCCESS: 'FETCH_EQUIPMENTS_FOR_DASHBOARD_SUCCESS',
  FETCH_EQUIPMENTS_FOR_DASHBOARD_ERROR: 'FETCH_EQUIPMENTS_FOR_DASHBOARD_ERROR',

  FETCH_EQUIPMENT_BY_ID: 'FETCH_EQUIPMENT_BY_ID',
  FETCH_EQUIPMENT_BY_ID_SUCCESS: 'FETCH_EQUIPMENT_BY_ID_SUCCESS',
  FETCH_EQUIPMENT_BY_ID_ERROR: 'FETCH_EQUIPMENT_BY_ID_ERROR',

  GET_UNIQUE_IDENTIFIER_SUGGESTIONS_LOADING: 'GET_UNIQUE_IDENTIFIER_SUGGESTIONS_LOADING',
  GET_UNIQUE_IDENTIFIER_SUGGESTIONS_SUCCESS: 'GET_UNIQUE_IDENTIFIER_SUGGESTIONS_SUCCESS',
  GET_UNIQUE_IDENTIFIER_SUGGESTIONS_ERROR: 'GET_UNIQUE_IDENTIFIER_SUGGESTIONS_ERROR',

  GET_UNIQUE_IDENTIFIER_COLLISIONS_LOADING: 'GET_UNIQUE_IDENTIFIER_SUGGESTIONS_LOADING',
  GET_UNIQUE_IDENTIFIER_COLLISIONS_SUCCESS: 'GET_UNIQUE_IDENTIFIER_COLLISIONS_SUCCESS',
  GET_UNIQUE_IDENTIFIER_COLLISIONS_ERROR: 'GET_UNIQUE_IDENTIFIER_COLLISIONS_ERROR',
  GET_UNIQUE_IDENTIFIER_COLLISIONS_RESET: 'GET_UNIQUE_IDENTIFIER_COLLISIONS_RESET',

  SAVE_UNIQUE_IDENTIFIER_LOADING: 'SAVE_UNIQUE_IDENTIFIER_LOADING',
  SAVE_OR_UPDATE_UNIQUE_IDENTIFIER_SUCCESS: 'SAVE_OR_UPDATE_UNIQUE_IDENTIFIER_SUCCESS',
  SAVE_OR_UPDATE_UNIQUE_IDENTIFIER_ERROR: 'SAVE_OR_UPDATE_UNIQUE_IDENTIFIER_ERROR',

  RESET_EQUIPMENT: 'RESET_EQUIPMENT',
} as const
